/**
 * OldRequestError is thrown when an old request is running while a new one is dispatched in the cases
 * where the data from the old one is not needed.
 * @class
 */
class OldRequestError extends (Error) {
    constructor(message) {
        super(message);
        this.name = 'OldRequestError';
    }
}

export default OldRequestError;
